import { CHAINLINK_ADDRESS } from "../constants";
import { ChainlinkAbi } from "../contracts/chainlink-abi";
import { getClient } from "../lib/client";
import type { ChainId } from "./vault-config";

interface GetEthPriceProps {
  chainId: ChainId;
}

export async function getEthPrice({
  chainId,
}: GetEthPriceProps): Promise<bigint> {
  const client = await getClient(chainId);
  const priceData = (await client.readContract({
    abi: ChainlinkAbi,
    address: CHAINLINK_ADDRESS,
    functionName: "latestRoundData",
    args: [],
  })) as Array<bigint>;

  if (!priceData || !priceData[1]) {
    throw new Error("Failed to fetch ETH price from Chainlink");
  }

  return priceData[1];
}
